export const FUNNEL = [
  { img: "/assets/funnel-01.png", step: "01", title: "Meta 廣告", text: "網紅影片／樂活素材吸引客人私訊" },
  { img: "/assets/funnel-02.png", step: "02", title: "自動回覆", text: "立刻收到專案介紹、LINE 連結與訂房電話" },
  { img: "/assets/funnel-03.png", step: "03", title: "LINE 選單", text: "點「人客多特惠專案」進入固定入口" },
  { img: "/assets/funnel-04.png", step: "04", title: "官網專案頁", text: "看方案內容，直接訂房或來電" },
];

export const METRICS = [
  { label: "曝光", value: "216,233", unit: "次／2個月" },
  { label: "觸及", value: "70,002", unit: "個帳號／2個月" },
  { label: "對名人堂有潛在興趣的人", value: "2,315", unit: "人／2個月", highlight: true },
  { label: "對專案有興趣的人", value: "187", unit: "人／2個月" },
];

export const SCENARIOS = [
  { name: "樂觀", rate: "8%", deals: 185, weekday: "NT$647,500", peak: "NT$1,110,000" },
  { name: "中等", rate: "5%", deals: 116, weekday: "NT$406,000", peak: "NT$696,000" },
  { name: "悲觀", rate: "3%", deals: 69, weekday: "NT$241,500", peak: "NT$414,000" },
];

export const PILLARS = [
  { no: "①", title: "開放帳號權限", text: "讓我們設定 FB 自動回覆、LINE 選單、官網專案頁與追蹤", owner: "名人堂行銷" },
  { no: "②", title: "訂房組接專案", text: "現場與電話訂房都能接「人客多專案」，並記錄來源", owner: "名人堂訂房組" },
  { no: "③", title: "人客多專案頁", text: "官網新增人客多專案頁，含 5 個不同價格房型專案", note: "確認方案內容：房型、價格、贈品與接駁規則定案", owner: "名人堂業務／營運" },
  { no: "④", title: "提供網紅招待", text: "10 組創作者入住拍攝，並確認分潤", owner: "名人堂業務" },
];

export const TASKS = [
  { group: "①", img: "/assets/funnel-01.png", result: "Meta 廣告上線", action: "需要 Meta 廣告帳號／粉絲頁廣告主權限，並設定付款方式", owner: "名人堂行銷", due: "10 月第 2 週" },
  { group: "①", img: "/assets/funnel-02.png", result: "私訊後自動收到專案介紹與 LINE 連結", action: "需要 FB 粉絲頁管理員權限，設定自動回覆與自動跳轉", owner: "名人堂行銷", due: "10 月第 2 週" },
  { group: "①", img: "/assets/funnel-03.png", result: "LINE 出現「人客多特惠專案」選單", action: "需要 LINE@ 管理員權限，設定新的圖文選單", owner: "名人堂行銷", due: "10 月第 3 週" },
  { group: "①", img: "/assets/funnel-04.png", result: "官網有「人客多專案」頁", action: "需要官網後台權限，或由官網廠商新增頁面", owner: "名人堂行銷／官網廠商", due: "10 月第 3 週" },
  { group: "①", icon: "chart", result: "從廣告到官網的轉換可以追蹤", action: "需要安裝官網追蹤碼（GA／Meta Pixel）的權限", owner: "名人堂行銷／官網廠商", due: "10 月第 3 週" },
  { group: "②", icon: "phone", result: "客人說「人客多專案」就能訂房", action: "需要現場訂房與電話訂房能接我們的專案（專案代碼、價格、話術）", owner: "名人堂訂房組", due: "10 月第 3 週" },
  { group: "②", icon: "list", result: "每通電話都知道從哪裡來", action: "需要每日登記來電來源、入住日期、人數、是否成交", owner: "名人堂訂房組", due: "上線起每日" },
  { group: "③", icon: "tag", result: "方案可以正式開賣", action: "需要確認房型、平假日售價、庫存、適用日期與排除日", owner: "名人堂業務／營運", due: "10 月第 1 週" },
  { group: "③", icon: "layout", result: "人客多專案頁上線，含 5 個不同價格房型專案", action: "需要提供 5 個房型專案的內容（房型、價格、照片），細節後訂", owner: "名人堂業務／營運", due: "10 月第 2 週" },
  { group: "③", icon: "gift", result: "贈品可以寫進廣告", action: "需要確認餐廳優惠、DIY 課程名額、KTV 贈送規則、高鐵接駁時段", owner: "名人堂營運", due: "10 月第 1 週" },
  { group: "④", icon: "video", result: "10 月底發第一支網紅影片", action: "需要提供 10 組招待房（每組 1–2 間），並確認分潤比例", owner: "名人堂業務", due: "10 月第 2 週起" },
];

export const TIMELINE = [
  { month: "10 月", title: "啟動", text: "確認方案、價格與追蹤設定，安排首批創作者入住；10 月底發第一支影片。" },
  { month: "11 月", title: "每週一支影片", text: "不同創作者輪流呈現房型、餐飲與親子體驗，持續曝光。" },
  { month: "12 月中", title: "完成入住", text: "10 組創作者招待入住與內容排程全部完成。" },
];

export const PLANS = [
  {
    id: "family",
    name: "網紅親子住房專案",
    target: "學齡前兒童家庭",
    highlights: ["平日入住史努比主題房享專案優惠", "搭配餐廳優惠，串聯住宿與餐飲", "贈送指定 DIY 課程體驗", "親子設施、撈魚餵魚、花園散步", "平假日分別訂價，售價含創作者分潤"],
    pending: ["房型與售價", "餐廳優惠", "DIY 贈送項目與名額", "分潤比例", "適用日期與排除日"],
  },
  {
    id: "senior",
    name: "退休族樂活平日專案",
    target: "北部無車退休族、好友結伴輕旅行",
    price: "NT$3,500／雙人房・晚，含早餐（建議價）",
    highlights: ["平日含早餐住房，輕鬆便利", "高鐵去程接駁調整至中午抵達，銜接午晚餐", "訂兩間房以上贈 KTV 1 小時，續唱可加購", "羽球、匹克球、泳池、三溫暖、SPA 與多元餐飲"],
    pending: ["房價與房型", "接駁站點與時段", "KTV 贈送及加購規則", "各項設施開放與收費"],
  },
];

export const CLICK_SCENARIOS = [
  { name: "保守", ctr: "0.7%", clicks: "1,514", rate: "3%", nights: 45 },
  { name: "中等", ctr: "0.85%", clicks: "1,838", rate: "5%", nights: 92 },
  { name: "樂觀", ctr: "1%", clicks: "2,162", rate: "8%", nights: 173 },
];

export const OTA_PRICES = [
  { label: "平日 NT$4,000", price: 4000 },
  { label: "旺日 NT$5,000", price: 5000 },
  { label: "假日 NT$8,000", price: 8000 },
];

export const PROJECT_PRICES = [
  { label: "平日 NT$3,500", price: 3500 },
  { label: "旺日 NT$6,000", price: 6000 },
];


export const TEAM_SCENARIOS = [
  { name: "保守", rate: "+8%", value: "+48 萬" },
  { name: "中等", rate: "+16%", value: "+96 萬" },
  { name: "樂觀", rate: "+25%", value: "+150 萬" },
];

export const SPILL_SCENARIOS = [
  { name: "保守", total: "約 NT$82–111 萬", team: "48 萬", ota: "18–36 萬", google: "15.75–27 萬" },
  { name: "中等", total: "約 NT$165–225 萬", team: "96 萬", ota: "36.8–73.6 萬", google: "32.2–55.2 萬" },
  { name: "樂觀", total: "約 NT$280–392 萬", team: "150 萬", ota: "69.2–138.4 萬", google: "60.55–103.8 萬" },
];
